import type { GlobalFeatureFlags } from "../store/globalFeatureFlag";

type TenantListItem = {
  appId?: number;
  descriptionJson?: string;
};

type TenantOnboardingResponse = {
  data?: {
    list?: TenantListItem[];
  };
};

type ParsedTenantOnboarding = {
  systemPatch: {
    isOldIdentifer: boolean;
    isOrganonDoc: boolean;
  };
  globalFeatureFlagPatch: Partial<GlobalFeatureFlags>;
};

const defaultParsedResult: ParsedTenantOnboarding = {
  systemPatch: {
    isOldIdentifer: false,
    isOrganonDoc: false,
  },
  globalFeatureFlagPatch: {
    serverPagination: true,
  },
};

function parseBooleanFlagValue(value: unknown): boolean | undefined {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    if (value === "true") return true;
    if (value === "false") return false;
  }
  return undefined;
}

export function parseTenantOnboardingResponseToRtqSettings(
  res: TenantOnboardingResponse,
): ParsedTenantOnboarding {
  try {
    const descriptionJson = res.data?.list?.find?.((item: TenantListItem) => {
      return item.appId === 8 && item.descriptionJson;
    })?.descriptionJson;

    if (!descriptionJson) return defaultParsedResult;

    const tempJson: {
      feature_flags?: {
        flagKey: string;
        ext?: string | boolean;
      }[];
    } = JSON.parse(descriptionJson);

    const isOldIdentifer = descriptionJson.includes("RTQ_IDENTIFIER");
    const isOrganonDoc = Boolean(
      tempJson?.feature_flags?.find((item) => item.flagKey === "RTQ_DOCS"),
    );

    const enableServerPaginationFlag = tempJson?.feature_flags?.find(
      (item) => item.flagKey === "enableServerPagination",
    );
    const enableDynamicQuestionAndResponseFlag = tempJson?.feature_flags?.find(
      (item) => item.flagKey === "enableDynamicQuestionAndResponse",
    );

    const enableServerPagination = parseBooleanFlagValue(
      enableServerPaginationFlag?.ext,
    );
    const enableDynamicQuestionAndResponse = parseBooleanFlagValue(
      enableDynamicQuestionAndResponseFlag?.ext,
    );

    return {
      systemPatch: {
        isOldIdentifer,
        isOrganonDoc,
      },
      globalFeatureFlagPatch: {
        serverPagination: enableServerPagination ?? true,
        ...(enableDynamicQuestionAndResponse !== undefined
          ? { enableDynamicQuestionAndResponse }
          : {}),
      },
    };
  } catch {
    return defaultParsedResult;
  }
}
